import { SpecificationAttribute as B2CSpecificationAttribute } from '@/b2c/shared/api/server-apis';
import { SpecificationAttribute as StoreContextSpecificationAttribute } from '@/storecontext/shared/api/server-apis';

export default function useProductSpecs() {
    const getSpecs = (specs: (B2CSpecificationAttribute | StoreContextSpecificationAttribute)[], names: string[] = ['Cover', 'Comfort', 'Base', 'SofaBaseHeight']): (B2CSpecificationAttribute | StoreContextSpecificationAttribute)[] => {
        return specs?.filter((spec: B2CSpecificationAttribute | StoreContextSpecificationAttribute) => names.indexOf(spec.name) > -1) ?? [];
    };

    const getWidth = (specs: (B2CSpecificationAttribute | StoreContextSpecificationAttribute)[]): string => {
        const spec = getSpecs(specs, ['NetWidth']);
        return spec && spec.length ? `${spec[0].label}: ${spec[0].value}` : '';
    };

    return {
        getSpecs,
        getWidth,
    };
}
